import share from '@devices/settings/device_settings/share.js';
import wave_application_settings from '@devices/settings/device_settings/wave_application_settings.js';
import wave_device_settings from '@devices/settings/device_settings/wave_device_settings.js';

export default {
	name: 'ShellyZwaveSensor',
	friendly_name: 'Z-Wave Sensor',
	family: 'sensor',
	isPM: false,
	gen: 'GZ',
	modes: {
		sensor: {
			channels: 1,
			notifications: ['offline', 'device_problem'],
			settings: [wave_application_settings, share, wave_device_settings],
		},
	},
};
